/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from '@reduxjs/toolkit';
import { menuReducer } from 'app/components/Menu/slice';
import { toasterBarReducer } from 'app/components/ToasterBar/slice';
import { preloadStateReducer } from 'app/helpers/PreloadStateHook/slice';
import { useUnauthorisedHandlerReducer } from 'app/helpers/UseUnauthorisedHandler/slice';

import { InjectedReducersType } from 'utils/types/injector-typings';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export function createReducer(injectedReducers: InjectedReducersType = {}) {
  return combineReducers({
    toasterBar: toasterBarReducer,
    menu: menuReducer,
    useUnauthorisedHandler: useUnauthorisedHandlerReducer,
    preloadState: preloadStateReducer,
    ...injectedReducers,
  });
}
